import { domainSlice } from '@modules/shared/slices/domain-slice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { docsVerificationSlice } from '@store/slices/docs-verification/docs-verification-slice';
import { sessionSlice } from '@store/slices/session-slice';
import { themeSlice } from '@store/slices/theme-slice';
import { toastSlice } from '@store/slices/toast-slice';

import { sdkApi } from './api';

const rootReducer = combineReducers({
    theme: themeSlice.reducer,
    session: sessionSlice.reducer,
    docsVerification: docsVerificationSlice.reducer,
    toast: toastSlice.reducer,
    domain: domainSlice.reducer,
    [sdkApi.reducerPath]: sdkApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore these paths in the state, they contain non-serializable functions
                ignoredPaths: [
                    'app.currentTheme.breakpointTo',
                    'app.currentTheme.breakpointFrom',
                    'app.currentTheme.breakpointBetween',
                    'toast.items',
                ],
            },
        }).concat(sdkApi.middleware),
});
